// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__k-afu","loading":"Spinner_loading__4I6qv","spinner":"Spinner_spinner__Z6H3Z","spin":"Spinner_spin__Q9zsz"};